<template>
  <div class="full-page">
    <h3 class="title">{{ materialConfig?.title }}</h3>
    <p class="desc">{{ materialConfig?.desc }}</p>
    <div class="material-box">
      <LazyList :list="materialConfig.firstRowList" v-if="isActive" />
      <LazyList
        :list="materialConfig.secondRowList"
        v-if="isActive"
        scrollType="right"
      />
      <LazyList :list="materialConfig.thridRowList" v-if="isActive" />
    </div>
  </div>
</template>
<script setup lang="ts">
const LazyList = defineAsyncComponent(() => import('./LazyList.vue'))
type materialConfigType = {
  title: string
  desc: string
  firstRowList: string[]
  secondRowList: string[]
  thridRowList: string[]
}
const { materialConfig, isActive } = defineProps({
  materialConfig: {
    type: Object as PropType<materialConfigType>,
    default: () => {
      return {}
    },
  },
  isActive: {
    type: Boolean,
    default: false,
  },
})
</script>
<style scoped lang="less">
.full-page {
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  flex-direction: column;
}
.title {
  color: #fff;
  text-align: center;
  font-family: PingFang SC;
  font-size: 0.48rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.desc {
  color: #fff;
  text-align: center;
  font-family: PingFang SC;
  font-size: 0.24rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  opacity: 0.6;
  margin-top: 0.16rem;
}
.material-box {
  margin-top: 0.8rem;
}
</style>
